module.exports = __webpack_public_path__ + "static/img/img_staff.c8f2c0de.jpg";